import React from 'react';
import { isIOS } from '../../../../../libs/utils/deviceDetector'
import DownloadButton from '../../../../../components/chat-tools-fool-componets/DownloadButton';

interface DownloadButtonWrapperProps {
  src: string;
  fileName: string;
  className: string;
}

const DownloadButtonWrapper: React.FC<DownloadButtonWrapperProps> = ({ src, fileName, className }) => (isIOS ? null : (
  <a
    className={`download-btn ${className}`}
    href={src}
    download={fileName}
    aria-label="download"
  >
    <DownloadButton />
  </a>
))

export default DownloadButtonWrapper;
